// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"f1353948","453":"fbaf8072","934":"aaaab12f"}[chunkId] + ".chunk.js";
};